import { PrepaymentPenalty } from 'pages/Admin/AdminTools/Configuration/Servicing/PrepaymentPenalty/constant'

import { defaultInputs } from './constants'

export const declarationsPenaltyValidate = (
  data: any,
  { prepaymentPenaltyConfig }: { prepaymentPenaltyConfig: PrepaymentPenalty[] },
) => {
  const fields = defaultInputs()

  const getValue = (key: string) => {
    if (data[key] !== undefined) return data[key]
    else return ''
  }

  const anyPrepaymentPenalty = getValue('anyPrepaymentPenalty')
  const otherPrepaymentPenalty = getValue('otherPrepaymentPenalty')
  const defaultInterest = getValue('defaultInterest')

  fields.otherPrepaymentPenaltyOption.disabled = !otherPrepaymentPenalty
  fields.otherPrepaymentPenaltyOption.options = prepaymentPenaltyConfig.map((p: PrepaymentPenalty) => p.label)
  ;[
    'anyPrepaymentPenaltyOption1',
    'anyPrepaymentPenaltyOption2',
    'anyPrepaymentPenaltyOption3',
    'anyPrepaymentPenaltyOption4',
  ].forEach((key) => {
    fields[key].disabled = !anyPrepaymentPenalty
  })
  ;[
    'defaultAfter',
    'defaultAfterUnit',
    'defaultEffectiveUntil',
    'defaultRateAppliesFrom',
    'retroactiveToDayDefaultRate',
    'defaultRateValue',
  ].forEach((key) => {
    fields[key].disabled = !defaultInterest
  })
  ;[
    'prepaymentPenaltyExpires',
    'distributeToLendersPrepayment',
    'distributeToOrigVendorPrepayment',
    'distributeToCompanyPrepayment',
  ].forEach((key) => {
    fields[key].disabled = !anyPrepaymentPenalty && !otherPrepaymentPenalty
  })

  return fields
}
